import * as React from 'react';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import styled from 'styled-components';

const RootStyled = styled(DropdownMenuPrimitive.Separator)`
  height: 1px;
  margin: 8px 0;
  background: ${({ theme }) => theme.colors.neutral.outline1};
` as typeof DropdownMenuPrimitive.Separator;

export const DropdownMenuSeparator = ({
  className,
  ...props
}: React.ComponentProps<typeof DropdownMenuPrimitive.Separator>): React.JSX.Element => {
  return <RootStyled data-slot="dropdown-menu-separator" className={className} {...props} />;
};
